import Selo from './selo';

export default class SeloService {
  constructor(resource) {
    let resources = {
      consultarSeloDigital: {
        method: "GET",
        url: 'consultarSeloDigital?numeroSelo={codigo}&hash={hash}'
      },
      consultarSeloFisico: {method: "GET", url: 'consultarSeloFisico?numeroSelo={codigo}&idTipoSelo={tipo}'},
    };

    this._resource = resource('consultarSelo', {}, resources);
  }

  mapItem = (item) => {
    const selo = item.selo;
    return new Selo(item);
  };

  buscarPorHash(codigo, hash) {
    return this._resource
      .consultarSeloDigital({codigo, hash})
      .then(res => res.json().then(this.mapItem));
  }

  buscarPorTipo(codigo, tipo) {
    return this._resource
      .consultarSeloFisico({codigo, tipo})
      .then(res => res.json().then(this.mapItem));
  }

}



// WEBPACK FOOTER //
// ./src/domain/selo/selo-service.js